import {ViewPopup} from './ViewPopup'
import {ClientUserState} from '../ClientUserState'

export class ViewPopupDiscordSettings extends ViewPopup {
    constructor() {
        super({key: 'strings:popups.errors.discordRedirectToWeb.title'}, {key: 'strings:popups.errors.discordRedirectToWeb.body', options: {username: ClientUserState.userState?.username}}, () => undefined, () => undefined, false)
        super.removeXButton()
        super.show()
    }
}
